import { timeStampFormat } from '@tencent/pmd-tools/lib/time';

const isToday = (time) => {
  const aDay = timeStampFormat(time, 'yyyyMMdd');
  const bDay = timeStampFormat(Date.now(), 'yyyyMMdd');
  return aDay === bDay;
};
function isYesterday(time) {
  let gap = 24 * 60 * 60;
  if (time.toString().length >= 11) {
    gap = gap * 1000;
  }
  const aDay = timeStampFormat(time + gap, 'yyyyMMdd');
  const bDay = timeStampFormat(Date.now(), 'yyyyMMdd');
  return aDay === bDay;
}


function formatTime(time = '') {
  if (!time) return '';
  if (isToday(time)) {
    return timeStampFormat(time, 'hh:mm');
  }
  if (isYesterday(time)) {
    return timeStampFormat(time, '昨天 hh:mm');
  }
  return timeStampFormat(time, 'MM-dd hh:mm');
}

function getShowContent(robotMsgObj: Record<string, any> = {}, content = '') {
  const { picUrl, content: robotContent } = robotMsgObj || {};
  if (picUrl) {
    return '【图片信息】';
  }
  if (content.indexOf('TipBusinessCard') > -1) {
    return '【名片信息】';
  }
  if (robotMsgObj.DataType === 'TEAM_APPLY') {
    return '【加入战队申请】';
  }
  if (robotMsgObj.DataType === 'TEAM_INVITATION') {
    return '【战队邀请函】';
  }
  if (robotMsgObj.DataType === 'TEAM_WEEKLY') {
    return '【战队周报】';
  }

  const str = content || robotContent || '';
  return str.replace('\\n', '').replace('\n', '');
}


export function parseConversationList(list) {
  const newList = list
    .filter(item => item.conversationID?.startsWith('C2C'))
    .map((item) => {
      const id = item.conversationID;
      const { nick, avatar, userID: uid } = item.userProfile || {};
      let content = item.lastMessage?.messageForShow;
      let robotMsgObj = {};
      const robotUidList = ['esportRobot', 'esportOfficialTeam', 'teamRobot'];
      if (robotUidList.includes(uid)) {
        try {
          const obj = JSON.parse(content);
          robotMsgObj = obj;
          content = obj.content;
        } catch (err) {
        }
      }

      const time = formatTime(item.lastMessage?.lastTime);
      const isRevoked = item.lastMessage?.isRevoked;
      const { unreadCount } = item;
      return {
        unreadCount,
        id,
        nick,
        avatar,
        content: item.isRevoked ? '' : getShowContent(robotMsgObj, content),
        time,
        timeStamp: item.lastMessage?.lastTime,
        robotMsgObj,
        isRevoked,
        showRedDot: unreadCount > 0 && id === 'C2CesportRobot',
      };
    });

  const HELPER_CON_ID = 'C2CesportRobot';
  newList.sort((a, b) => {
    if (a.id === HELPER_CON_ID) return -1;
    if (b.id === HELPER_CON_ID) return 1;
    return 0;
  });
  return newList;
}
